import Marquee from './components/Marquee'
export default Marquee 